import { AnalyseViewTreeGroupNode } from '../analyse';

export function isAnalyseViewTreeGroupNode(data: any): data is AnalyseViewTreeGroupNode {
  return (data as AnalyseViewTreeGroupNode).from !== undefined;
}
